'use strict';

function errorHandlerService() {
  return {
    updateModalError: updateModalError
  };


  function resolveErrorMsg(error) {
    var statusText = 'Okänt fel.';

    if (error.status) {
      if (error.status === -1) { // -1 is Network error
        return 'Kunde inte nå nätverket. Vänligen kontrollera din uppkoppling';
      }
      if (error.statusText) {
        statusText = error.statusText + ' (' + error.status + ')';
        return statusText;
      }
    }
    return statusText;
  }

  function updateModalError(modal, error) {
    var msg = resolveErrorMsg(error);
    modal.$scope.errorMessage = msg;
  }

}

module.exports = errorHandlerService;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/services/errorhandler.service.js
 ** module id = 317
 ** module chunks = 0
 **/